import { getPCIDSSMapping } from '@/features/pcidss/helpers/getPCIDSSMapping';
import { IRequestConfig } from '@/features/pcidss/store/pcidss.types';
import { store } from '@/store/configuration';
import { IDashboardConfig } from '@/store/models/dashboard-config.model';

export function filterPCIDSSEnpoint(
  originalRequest: IRequestConfig,
  config: IDashboardConfig | undefined = undefined,
): IRequestConfig {
  if (config === undefined) {
    try {
      config = store.getState().dashboardConfig.config;
    } catch (error) {
      console.error(error);
    }
  }

  if (config?.settings?.pcidss) {
    const filteredRequest = getPCIDSSMapping({
      ...originalRequest,
      pathname: originalRequest.pathname.replace(config.api.baseUrl, ''),
      baseURL: originalRequest.baseURL,
    });
    return filteredRequest;
  }
  return originalRequest;
}
